import { useIntl } from 'react-intl';
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import dashAppService from '../../services/dashAppService';
import useNotifications from '../../hooks/useNotifications';
import Spinner from '../../components/Spinner/Spinner';
import { refreshAccessToken } from '../../services/requestService';

const DashApp: React.FC = () => {
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const productId = searchParams.get('productId');

  const [dashAppUrl, setDashAppUrl] = useState<string>('');
  const { notify } = useNotifications();
  const intl = useIntl();

  useEffect(() => {
    const event = new CustomEvent<'normal' | 'compact'>('setNavState', {
      detail: 'compact',
    });
    window.dispatchEvent(event);
  }, []);

  const title = intl.formatMessage({
    id: 'dashApp.title',
  });

  useEffect(() => {
    const refreshToken = async () => {
      await refreshAccessToken();
    };

    refreshToken();

    const intervalId = setInterval(refreshToken, 4 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);

  const { isLoading } = useQuery([], () => dashAppService.getDashAppUrl(companyId!, productId!), {
    onSuccess: (response) => {
      setDashAppUrl(response.url);
    },
    onError: () => notify('error', title, intl.formatMessage({ id: 'dashapp.unableLoadDashApp' })),
  });

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      {isLoading ? (
        <Spinner />
      ) : (
        <iframe
          src={dashAppUrl}
          title={title}
          style={{ width: '100%', height: '100%', border: 'none', backgroundColor: 'white' }}
        />
      )}
    </div>
  );
};

export default DashApp;
